export default __webpack_public_path__ + "static/staples-655873070525d76d12bdeb268064a4fc.svg";